import { get, post } from '../utils/api';
import { createTeamsPayload, DepartmentResponse, updateTeamsPayload } from '../features/jobApplication/JobApplicationTypes';
import { put } from '../utils/api';
import { formatUrl } from '../utils/urlFormatter';



const update_job_application = '/{0}/{1}/jobApplication.update';
const fetch_job_application_details = '/{0}/{1}/jobApplication.detail';
const create_job_application_steps = '/{0}/applicationQuestion.createUpdate';
const fetch_job_application_question_details = '/{0}/{1}/applicationQuestion.list';
const fetch_interview_question = '/{0}/{1}/aiInterview.list';
const fetch_interview_question_detail = '/{0}/{1}/aiInterview.detail';

const credentialsConfig = {
    withCredentials: true,
}


export const updateJobApplicationData = async (baseId: number, id: number, data: updateTeamsPayload): Promise<DepartmentResponse> => {
    const update_job_data = formatUrl(update_job_application, [baseId, id]);
    return put<DepartmentResponse>(update_job_data, data, credentialsConfig);
};


export const fetchJobApplicationDetails = async (baseId: number, jobId: number): Promise<DepartmentResponse> => {
  const fetch_location_data = formatUrl(fetch_job_application_details, [baseId, jobId]);
  return get<DepartmentResponse>(fetch_location_data, credentialsConfig);
};

export const fetchInterviewList = async (baseId: number, jobId: number): Promise<DepartmentResponse> => {
  const fetch_location_data = formatUrl(fetch_interview_question, [baseId, jobId]);
  return get<DepartmentResponse>(fetch_location_data, credentialsConfig);
};
export const fetchInterviewDetails = async (baseId: number, interviewId: number): Promise<DepartmentResponse> => {
  const fetch_location_data = formatUrl(fetch_interview_question_detail, [baseId, interviewId]);
  return get<DepartmentResponse>(fetch_location_data, credentialsConfig);
};

export const createJobApplicationStepData = async (data: createTeamsPayload[], userId: number): Promise<DepartmentResponse> => {
    const base_create_location = formatUrl(create_job_application_steps, [userId]);
    return post<DepartmentResponse>(base_create_location, data , credentialsConfig);
};

export const fetchQuestionListData = async (baseId: number, jobId: number): Promise<DepartmentResponse> => {
    const fetch_location_data = formatUrl(fetch_job_application_question_details, [baseId, jobId])+"?question_type=external";;
    return get<DepartmentResponse>(fetch_location_data, credentialsConfig);
};